import { api } from './client';

export const fetchUserMe = () => api.get('/api/user/me');

export const fetchBrandManager = (brdCd) =>
  api.get('/api/users/brand-manager', { query: { brd_cd: brdCd } });

export const writeUserLog = (payload) => api.post('/api/user/log', payload);
